export default "__VITE_ASSET__zHBmPsJn__"